import * as Types from './Types'
import * as api from './api'

export function showAlert(
  header,
  text,
  type,
  firstButton = { title: '', onPress: () => {} },
  secondButton = { title: '', onPress: () => {} },
  thirdButton = { title: '', onPress: () => {} }
) {
  return dispatch => {
    dispatch({
      type: Types.SHOW_ALERT,
      payload: {
        header,
        text,
        type,
        firstButton,
        secondButton,
        thirdButton
      }
    })
  }
}

export function hideAlert() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_ALERT
    })
  }
}

export function showNewUserModal(apartmentId) {
  return dispatch => {
    dispatch({
      type: Types.SHOW_NEW_USER_MODAL,
      payload: apartmentId
    })
  }
}

export function hideNewUserModal() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_NEW_USER_MODAL
    })
  }
}

export function showEditUserModal(user) {
  return dispatch => {
    dispatch({
      type: Types.SHOW_EDIT_USER_MODAL,
      payload: user
    })
  }
}

export function hideEditUserModal() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_EDIT_USER_MODAL
    })
  }
}

export function showSelectCommunityModal() {
  return dispatch => {
    dispatch({
      type: Types.SHOW_SELECT_COMMUNITY_MODAL
    })
  }
}

export function hideSelectCommunityModal() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_SELECT_COMMUNITY_MODAL
    })
  }
}

export function showSnackbar(message) {
  return dispatch => {
    dispatch({
      type: Types.SHOW_SNACKBAR,
      payload: message
    })
  }
}

export function hideSnackbar() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_SNACKBAR
    })
  }
}

export function setCurrentPage(page) {
  return dispatch => {
    dispatch({
      type: Types.SET_CURRENT_PAGE,
      payload: page
    })
  }
}

export function showEditLaundryTimeModal(laundryTime) {
  return dispatch => {
    dispatch({
      type: Types.SHOW_EDIT_LAUNDRY_TIME_MODAL,
      payload: laundryTime
    })
  }
}

export function hideEditLaundryTimeModal() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_EDIT_LAUNDRY_TIME_MODAL
    })
  }
}

export function showCreateLaundryTimeModal() {
  return dispatch => {
    dispatch({
      type: Types.SHOW_CREATE_LAUNDRY_TIME_MODAL
    })
  }
}

export function hideCreateLaundryTimeModal() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_CREATE_LAUNDRY_TIME_MODAL
    })
  }
}

export function showEditLaundryModal(laundry) {
  return dispatch => {
    dispatch({
      type: Types.SHOW_EDIT_LAUNDRY_MODAL,
      payload: laundry
    })
  }
}

export function hideEditLaundryModal() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_EDIT_LAUNDRY_MODAL
    })
  }
}

export function showCreateLaundryModal() {
  return dispatch => {
    dispatch({
      type: Types.SHOW_CREATE_LAUNDRY_MODAL
    })
  }
}

export function hideCreateLaundryModal() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_CREATE_LAUNDRY_MODAL
    })
  }
}

export function showEditLaundryTypeModal() {
  return dispatch => {
    dispatch({
      type: Types.SHOW_EDIT_LAUNDRY_TYPE_MODAL
    })
  }
}

export function hideEditLaundryTypeModal() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_EDIT_LAUNDRY_TYPE_MODAL
    })
  }
}

export function showEditBookingRangeModal() {
  return dispatch => {
    dispatch({
      type: Types.SHOW_EDIT_BOOKING_RANGE_MODAL
    })
  }
}

export function hideEditBookingRangeModal() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_EDIT_BOOKING_RANGE_MODAL
    })
  }
}

export function showEditMaxBookingsModal() {
  return dispatch => {
    dispatch({
      type: Types.SHOW_EDIT_MAX_BOOKINGS_MODAL
    })
  }
}

export function hideEditMaxBookingsModal() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_EDIT_MAX_BOOKINGS_MODAL
    })
  }
}

export function showEditInformationItemModal(informationItem) {
  return dispatch => {
    dispatch({
      type: Types.SHOW_EDIT_INFORMATION_ITEM_MODAL,
      payload: informationItem
    })
  }
}

export function hideEditInformationItemModal() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_EDIT_INFORMATION_ITEM_MODAL
    })
  }
}

export function showCreateInformationItemModal() {
  return dispatch => {
    dispatch({
      type: Types.SHOW_CREATE_INFORMATION_ITEM_MODAL
    })
  }
}

export function hideCreateInformationItemModal() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_CREATE_INFORMATION_ITEM_MODAL
    })
  }
}

export function showBookOrbookOrUnbookLaundryTimeModal(apartment) {
  return dispatch => {
    dispatch({
      type: Types.SHOW_UNBOOK_LAUNDRY_TIME_MODAL,
      payload: apartment
    })
  }
}

export function hideBookOrbookOrUnbookLaundryTimeModal() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_UNBOOK_LAUNDRY_TIME_MODAL
    })
  }
}

export function showCreateBookingSystemModal() {
  return dispatch => {
    dispatch({
      type: Types.SHOW_CREATE_BOOKING_SYSTEM_MODAL
    })
  }
}

export function hideCreateBookingSystemModal() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_CREATE_BOOKING_SYSTEM_MODAL
    })
  }
}

export function showEditBookingSystemModal(system) {
  return dispatch => {
    dispatch({
      type: Types.SHOW_EDIT_BOOKING_SYSTEM_MODAL,
      payload: system
    })
  }
}

export function hideEditBookingSystemModal() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_EDIT_BOOKING_SYSTEM_MODAL
    })
  }
}

export function showCreateBookingSystemTimeModal(systemId) {
  return dispatch => {
    dispatch({
      type: Types.SHOW_CREATE_BOOKING_SYSTEM_TIME_MODAL,
      payload: systemId
    })
  }
}

export function hideCreateBookingSystemTimeModal() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_CREATE_BOOKING_SYSTEM_TIME_MODAL
    })
  }
}

export function showEditBookingSystemTimeModal(systemId, time) {
  return dispatch => {
    dispatch({
      type: Types.SHOW_EDIT_BOOKING_SYSTEM_TIME_MODAL,
      payload: { systemId, time }
    })
  }
}

export function hideEditBookingSystemTimeModal() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_EDIT_BOOKING_SYSTEM_TIME_MODAL
    })
  }
}

export function toggleLaundryVisibility() {
  return async (dispatch, getState) => {
    const { data, user } = getState()
    const communityId = data.community.id
    const currentValue = data.community.showApartmentInLaundry

    dispatch({
      type: Types.TOGGLE_LAUNDRY_VISIBILITY
    })

    try {
      const response = await api.toggleLaundryVisibility(user.token, communityId, !currentValue)
      
      dispatch({
        type: Types.TOGGLE_LAUNDRY_VISIBILITY_SUCCESS,
        payload: !currentValue
      })
    } catch (error) {
      console.error('Error toggling laundry visibility:', error)
      dispatch({
        type: Types.TOGGLE_LAUNDRY_VISIBILITY_FAIL,
        payload: error
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/actions/Config.js